import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ErrorHandler, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

// Services
import { RouteService } from './services/route.service';

// Interceptors
import { ApiInterceptorService } from './services/http-interceptors/api-interceptor.service';
import { AuthInterceptorService } from './services/http-interceptors/auth-interceptor.service';
import { GlobalErrorsHandler } from './errors/global-errors.handler';
import { RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';

@NgModule({
  imports: [CommonModule, RouterModule],
  exports: []
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. You should only import Core modules in the AppModule only.');
    }
  }

  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        GlobalErrorsHandler,
        {
          provide: ErrorHandler,
          useExisting: GlobalErrorsHandler
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: ApiInterceptorService,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthInterceptorService,
          multi: true
        },
        {
          provide: RECAPTCHA_LANGUAGE,
          useValue: 'en-US'
        },
        {
          provide: RECAPTCHA_SETTINGS,
          useValue: { siteKey: environment.recaptcha.siteKey } as RecaptchaSettings
        },
        { provide: TINYMCE_SCRIPT_SRC, useValue: 'assets/tinymce/tinymce.min.js' },
        RouteService
      ]
    };
  }
}
